export default __webpack_public_path__ + "static/media/mc_closelid_icon.6f198843.svg";